// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import navBar from '@/components/navBar'
import axios from 'axios'
import swal from 'sweetalert2'

require('es6-promise').polyfill()

Vue.config.productionTip = false

Vue.component('navBar', navBar)

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    links: '',
    userName: '',
    userStatus: '',
    reportResults: {},
    searchResults: {},
    userType: ''
  },
  mutations: {
    setLinks (state, links) {
      state.links = links
    },
    setUserName (state, username) {
      state.userName = username
    },
    setUserStatus (state, userStatus) {
      state.userStatus = userStatus
    },
    reportResults (state, reportResults) {
      state.reportResults = reportResults
    },
    searchResults (state, searchResults) {
      state.searchResults = searchResults
    },
    userType(state, userType){
      state.userType = userType
    }
  },
  actions: {
    setLinks ({ commit }, links) {
      commit('setLinks', links)
    },
    setUserName ({commit}, username) {
      commit('setUserName', username)
    },
    setUserStatus ({commit}, userStatus) {
      commit('setUserStatus', userStatus)
    }
  },
  getters: {
    getUserName (state) {
      return state.userName
    },
    getLinks (state) {
      return state.links
    },
    getUserStatus (state) {
      return state.userStatus
    },
    reportResults (state) {
      return state.reportResults
    },
    searchResults (state) {
      return state.searchResults
    },
    userType(state) {
      return state.userType
    }
  }
})

Vue.mixin({
  methods: {
    checkSession () {
      axios.post('./static/api/Ajax.php', {
        action: 'Check Session'
      }).then((response) => {
        if (response.data.status !== 'success') {
          swal(response.data.status)
          setTimeout(() => {
            window.location = './'
          }, 2000)
        } else if (response.data.status === 'success') {
          this.$store.dispatch('setUserName', response.data.username)
          this.$store.dispatch('setUserStatus', response.data.userStatus)
        }
      }).catch((e) => {
        console.log(e)
      })
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js